import axios from "axios"
import { StudyPreActivityHeaders } from "../_models/app.models";

const getStyles = (plantCode:string,factoryCode:string,module:string,style:string)=>
{
    // var data = {data:[{style:{name:'TestCode'}},{style:{name:'TestCode'}}]}
    // return new Promise((resolve,reject)=>{resolve(data)});
    return axios.get(`/api/v1/styles`,{params:{plantCode:plantCode,factoryCode:factoryCode,module:module,style:style}});
}

const getPreActivityStudyHeader = (preStudyActivityHeaderId:number,plantCode:string|null|undefined,factoryCode:string|null|undefined,module:string|null|undefined,shiftCode:string|null|undefined,style:string|null|undefined,styleVersion:string|null|undefined,isLatest:boolean|null|undefined)=>
{
    if(preStudyActivityHeaderId!=undefined && preStudyActivityHeaderId!=0)
    {
    return axios.get(`/api/v1/studies/studyPreActivityHeaders/${preStudyActivityHeaderId}`,{params:{plantCode:plantCode,factoryCode:factoryCode,module:module,shiftCode:shiftCode,style:style,styleVersion:styleVersion,isLatest:isLatest}})
    }
    else
    {
        return axios.get('/api/v1/studies/studyPreActivityHeaders',{params:{plantCode:plantCode,factoryCode:factoryCode,module:module,shiftCode:shiftCode,style:style,styleVersion:styleVersion,isLatest:isLatest}})
    }
}
const addPreActivityStudyHeader = (payload:StudyPreActivityHeaders)=>{
    return axios.post('/api/v1/studies/addStudyPreActivityHeaders',payload);
}
const getOperations = (plantCode:string|null|undefined,factoryCode:string|null|undefined,module:string|null|undefined,style:string|null|undefined,styleVersion:string|null|undefined)=>{
    // var data = {data:[{operationSeq:1,operationName:'Test Ops Name',gsdCode:'Test GSD Codes'},{operationSeq:2,operationName:'Test Ops Name 2',gsdCode:'Test GSD Codes 2'}]}
    // return new Promise((resolve,reject)=>{resolve(data)});
    return axios.get('/api/v1/operations',{params:{plantCode:plantCode,factoryCode:factoryCode,module:module,style:style,version:styleVersion}})
}
const getElementCategories = ()=>{
    return new Promise((resolve,reject)=>{resolve(createElementCategories())});
}
const getElementNames = ()=>{
    return axios.get('/api/v1/studyelements')
}

const createElementCategories = ()=>{
    return {
        data:
        [
            {id:1,name:'M-Manual'},
            {id:2,name:'A-Auto'},
            {id:3,name:'W-Walk'},
            {id:4,name:'MT-Machine Time'}    
    ]
    }
}


export const preStudyService = {
    getStyles,
    getPreActivityStudyHeader,
    addPreActivityStudyHeader,
    getOperations,
    getElementCategories,
    getElementNames
}